import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'df-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent {
  @Input() title: string = 'Info';
  @Input() message: string = '';

  constructor(public activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.close(true);
  }
}
